// 환자 관리
import PatientList from "views/patient/PatientList";
import PatientView from "views/patient/PatientView";
import PatientWrite from "views/patient/PatientWrite";
import PatientEdit from "views/patient/PatientEdit";

// 간병인 관리
import CaregiverList from "views/caregiver/CaregiverList";
import CaregiverView from "views/caregiver/CaregiverView";
import CaregiverWrite from "views/caregiver/CaregiverWrite";
import CaregiverEdit from "views/caregiver/CaregiverEdit";

// 공고 관리
import AnnouncementList from "views/announcement/AnnouncementList";
import AnnouncementView from "views/announcement/AnnouncementView";

// 공지사항 관리
import NoticeList from "views/notice/NoticeList";
import NoticeView from "views/notice/NoticeView";
import NoticeWrite from "views/notice/NoticeWrite";
import NoticeEdit from "views/notice/NoticeEdit";

// 정산 관리
import SettlementList from "views/settlement/SettlementList";

// 병원 관리
import HospitalList from "views/hospital/HospitalList";
import HospitalView from "views/hospital/HospitalView";
import HospitalWrite from "views/hospital/HospitalWrite";
import HospitalEdit from "views/hospital/HospitalEdit";

var routes = [
  {
    path: "/patients",
    name: "환자 관리",
    icon: "nc-icon nc-single-02",
    component: PatientList,
    layout: "/admin",
  },
  {
    path: "/patients/write",
    name: "환자 등록",
    icon: "nc-icon nc-simple-add",
    component: PatientWrite,
    layout: "/admin",
  },
  {
    path: "/patients/:id/edit",
    name: "환자 정보 수정",
    icon: "nc-icon nc-ruler-pencil",
    component: PatientEdit,
    layout: "/admin",
  },
  {
    path: "/patients/:id",
    name: "환자 정보",
    icon: "nc-icon nc-single-02",
    component: PatientView,
    layout: "/admin",
  },
  {
    path: "/caregivers",
    name: "간병인 관리",
    icon: "nc-icon nc-single-02",
    component: CaregiverList,
    layout: "/admin",
  },
  {
    path: "/caregivers/write",
    name: "간병인 등록",
    icon: "nc-icon nc-simple-add",
    component: CaregiverWrite,
    layout: "/admin",
  },
  {
    path: "/caregivers/:id/edit",
    name: "간병인 정보 수정",
    icon: "nc-icon nc-ruler-pencil",
    component: CaregiverEdit,
    layout: "/admin",
  },
  {
    path: "/caregivers/:id",
    name: "간병인 정보",
    icon: "nc-icon nc-single-02",
    component: CaregiverView,
    layout: "/admin",
  },
  {
    path: "/announcements",
    name: "공고 관리",
    icon: "nc-icon nc-tile-56",
    component: AnnouncementList,
    layout: "/admin",
  },
  {
    path: "/announcements/:id",
    name: "공고 정보",
    icon: "nc-icon nc-tile-56",
    component: AnnouncementView,
    layout: "/admin",
  },
  {
    path: "/settlements",
    name: "정산관리",
    icon: "nc-icon nc-money-coins",
    component: SettlementList,
    layout: "/admin",
  },
  {
    path: "/hospitals",
    name: "병원 관리",
    icon: "nc-icon nc-ambulance",
    component: HospitalList,
    layout: "/admin",
  },
  {
    path: "/hospitals/write",
    name: "병원 등록",
    icon: "nc-icon nc-simple-add",
    component: HospitalWrite,
    layout: "/admin",
  },
  {
    path: "/hospitals/:id/edit",
    name: "병원 정보 수정",
    icon: "nc-icon nc-ruler-pencil",
    component: HospitalEdit,
    layout: "/admin",
  },
  {
    path: "/hospitals/:id",
    name: "병원 정보",
    icon: "nc-icon nc-ambulance",
    component: HospitalView,
    layout: "/admin",
  },
  {
    path: "/notices/:userType",
    name: "공지사항 관리",
    icon: "nc-icon nc-bell-55",
    component: NoticeList,
    layout: "/admin",
  },
  {
    path: "/notices/:userType/write",
    name: "공지사항 작성",
    icon: "nc-icon nc-bell-55",
    component: NoticeWrite,
    layout: "/admin",
  },
  {
    path: "/notices/:userType/:id",
    name: "공지사항 정보",
    icon: "nc-icon nc-bell-55",
    component: NoticeView,
    layout: "/admin",
  },
  {
    path: "/notices/:userType/:id/edit",
    name: "공지사항 수정",
    icon: "nc-icon nc-bell-55",
    component: NoticeEdit,
    layout: "/admin",
  },
];

export default routes;
